<template>
  <section class="relative w-full custom-scrollbar overflow-x">
    <table class="w-full bg-white table-auto min-w-max">
      <thead class="text-gray-400 bg-white border-b border-gray-200">
        <tr>
          <th class="p-3 text-sm text-left">Profile</th>
          <th class="p-3 text-sm text-left">Payrun</th>
          <th class="p-3 text-sm text-left">Net Salary</th>
          <th class="p-3 text-sm text-left">Payslip</th>
          <th class="p-3 text-sm text-left">Payrun Type</th>
          <th class="p-3 text-sm text-left">Status</th>
          <th class="p-3 text-sm text-left">Date Process</th>
          <th class="p-3 text-sm text-left">Account Credit</th>
          <th class="p-3 text-sm text-left">Account Debit</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(process, index) in payrunsProcess" :key="index">
          <td class="text-sm">{{ process.payrun.emp_id.emp_fullname }}</td>
          <td>
            <p class="text-sm">
              {{ process.payrun.payrun_period.periodic_month }}
            </p>
            <span class="text-xs text-gray-500">{{
              periodicRange(process.payrun.payrun_period)
            }}</span>
          </td>
          <td>
            {{ formatCurrency(process.payrun.payrun_net_salary) }}
          </td>
          <td>
            <Button
              class="w-20 mr-2 text-sm text-white bg-gray-400 rounded h-9 hover:opacity-70"
              @click="showPayrun(process.payrun)"
            >
              View
              <font-awesome-icon icon="fa-eye" class="ml-2" />
            </Button>
          </td>
          <td>
            <div
              class="px-4 py-1 text-center text-white rounded-2xl"
              :class="stylePayrunType(process.payrun.payrun_type?.color)"
            >
              {{
                process.payrun.payrun_type !== null
                  ? process.payrun.payrun_type?.payrun_type
                  : "-"
              }}
            </div>
          </td>
          <td>
            <SwitchButton
              class="w-max"
              @update:model="(value) => updatePayrunStatus(value, process)"
              :value="process.payrun.emp_id.payrun_status"
            />
          </td>
          <td>
            {{
              process.payrun.process_date !== null
                ? moment(process.payrun.process_date).format("DD/MM/YYYY")
                : "-"
            }}
          </td>
          <td class="text-sm">
            <p>{{ process.bank?.bi_bank_name }}</p>
            <p>{{ process.bank?.bi_account_number }}</p>
            <p>{{ process.bank?.bi_holder_name }}</p>
          </td>
          <td class="text-sm">
            <p>{{ process.bankPayrun?.bank_name }}</p>
            <p>{{ process.bankPayrun?.account_number }}</p>
            <p>{{ process.bankPayrun?.company_id.company_name }}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
  <ModalView
    :payrun="payrun"
    v-if="modal.show"
    :modal-title="modal.title"
    @close-modal="modal.show = false"
  />
</template>

<script>
import moment from "moment";
import Button from "@/components/Button.vue";
import ModalView from "@/components/PayrunProcess/ModalView.vue";
import SwitchButton from "@/components/SwitchButton.vue";

export default {
  name: "TablePayrunProcess",
  components: {
    Button,
    ModalView,
    SwitchButton,
  },
  props: {
    payrunsProcess: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return { moment };
  },
  data() {
    return {
      payrun: null,
      modal: {
        title: "",
        show: false,
      },
    };
  },
  methods: {
    periodicRange(period) {
      return `${moment(period.periodic_start_date).format(
        "DD MMMM"
      )} - ${moment(period.periodic_end_date).format("DD MMMM")}`;
    },
    formatCurrency(number) {
      const formatter = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      });
      return formatter.format(Math.round(number));
    },
    showPayrun(payrun) {
      this.modal = {
        title: "Payrun",
        show: true,
      };
      this.payrun = payrun;
    },
    closeModal() {
      this.modal = {
        title: "",
        show: false,
      };
      this.payrun = null;
    },
    stylePayrunType(color) {
      if (color === "gray") {
        return "bg-gray-500";
      } else if (color === "green") {
        return "bg-green-500";
      } else if (color === "orange") {
        return "bg-orange-500";
      } else {
        return "";
      }
    },
    updatePayrunStatus(value, process) {
      const empId = process.payrun.emp_id._id;
      this.$emit("on-update-status", value, empId);
    },
  },
};
</script>

<style scoped>
.overflow-x {
  overflow-x: scroll;
}
table thead th,
table tbody tr td {
  padding: 1rem 2rem;
}
.custom-scrollbar::-webkit-scrollbar {
  height: 8px !important;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: #c6c8cc;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #a1a1a1;
}
</style>
